<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('chief_complaint')" icon="briefcase">
            <app-default-button @click="openModal()" v-if="this.$can('create_chief_complaint')"
                :title="$fieldTitle('add', 'chief_complaint', true)" />
        </app-page-top-section>

        <app-table v-if="options.url" :id="table_id" :options="options" @action="triggerActions" />

        <app-chief-complaint-modal v-if="isModalActive" v-model="isModalActive" :selected-url="selectedUrl"
            @close="isModalActive = false" />

        <app-confirmation-modal v-if="confirmationModalActive" icon="trash-2" modal-id="app-confirmation-modal"
            @confirmed="confirmed('chief-complaint-table')" @cancelled="cancelled" />
    </div>
</template>

<script>

import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import ChiefComplaintMixin from "../../Mixins/ChiefComplaintMixin";
import CoreLibrary from "../../../../core/helpers/CoreLibrary";
import { CHIEF_COMPLAINT, CUSTOMERS_EXPORT } from "../../../Config/ApiUrl-CPB";
import { urlGenerator } from "../../../../common/Helper/AxiosHelper";

export default {
    name: "ChiefComplaint",
    mixins: [HelperMixin, ChiefComplaintMixin],
    data() {
        return {
            table_id: 'chief-complaint-table',
            isModalActive: false,
            selectedUrl: '',
            totalCustomer: '',
            urlGenerator,
        }
    },
    extends: CoreLibrary,
    methods: {
        triggerActions(row, action, active) {

            if (action.title === this.$t('edit')) {
                this.selectedUrl = `${CHIEF_COMPLAINT}/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },

        openModal() {
            this.isModalActive = true;
            this.selectedUrl = ''
        },

        exportCustomers() {
            window.location = CUSTOMERS_EXPORT;
        },
    }
}
</script>